module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/is-pure.js
// module id = 161
// module chunks = 0